import actionStates from "./ActionStates";
import cursors from "./Cursors";
import navigation from "./Navigation";
import ratio from "./Ratio";
import publish from "./Publish";
import participants from "./Participants";
import video from "./Video";
import apps from "./Apps";
import indicators from "./Indicators";

const iconsMap = {
  ...actionStates,
  ...cursors,
  ...navigation,
  ...ratio,
  ...publish,
  ...participants,
  ...video,
  ...apps,
  ...indicators,
} as const;

export default iconsMap;

export type IconMapMember = keyof typeof iconsMap | (string & {});
